import React from "react";

import { Modal } from "../../../components/Modal/Modal";
import { useImportMigrationWizard } from "../../../components/ImportMigrationModal/useImportMigrationWizard";
import {
  MigrationWizardActions,
  MigrationWizardBody,
} from "../../../components/ImportMigrationModal/MigrationWizard";

interface NetworkIntegration {
  l1Id: number;
  integrationType: string;
}

interface NetworkIntegrationEditModalProps {
  network: NetworkIntegration;
  portfolioId: string;
  isConnect: boolean;
  onClose: () => void;
  onRefresh?: () => Promise<void>;
}

export const NetworkIntegrationEditModal: React.FC<NetworkIntegrationEditModalProps> = ({
  network,
  portfolioId,
  isConnect,
  onClose,
  onRefresh,
}) => {
  const wizard = useImportMigrationWizard({
    l1Id: network.l1Id,
    currentPortfolioId: portfolioId,
    importType: network.integrationType,
    isConnect,
    isOpen: true,
    onClose,
    onSuccess: onRefresh,
  });

  return (
    <Modal
      maxWidth="sm"
      fullWidth
      withoutTopBorder
      onClose={onClose}
      actions={<MigrationWizardActions wizard={wizard} onCancel={onClose} />}
    >
      <MigrationWizardBody wizard={wizard} />
    </Modal>
  );
};
